import axios from "axios";
import { BU_KEY } from "@/context/BusinessUnitContext";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "stretchops_token";

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Attach current vertical so backend can filter/stamp tenant-scoped data.
  // Backend defaults to stretch_film when the header is absent, so we only
  // set it when the user has explicitly picked one.
  try {
    const bu = localStorage.getItem(BU_KEY);
    if (bu) config.headers["X-Business-Unit"] = bu;
  } catch { /* localStorage unavailable — server will default */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
